import React from 'react'
import FrameComponent from '../../Components/iFrame/FrameComponent'

const HomePage = () => {
  return (
    <div>
        <h5 style={{color:'green'}}>Registro de personal y vehiculos</h5>
        <FrameComponent source={'https://www.youtube.com/embed/Pvl_u6VdyVY'} height={'450px'} width={'100%'} />
        <h5 style={{color:'green'}}>Registrar una nueva solicitud</h5>
        <FrameComponent source={'https://www.youtube.com/embed/r5LweDyIdbA'} height={'450px'} width={'100%'} />
    </div>
  )
}

export default HomePage